var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-count-image-slot"},[_c('image-stream',{staticClass:"frame",attrs:{"src":("https://product-count.omniview.cloud/frame.jpg?id=" + _vm.id)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }